export const ToolbarHelpers = {
	notifications: [
  		{
	        id: 'id',
	        title: 'Mail 5',
	        lastTime: '23 Minutes ago',
	        state: 'state'
	    },
	    {
	        id: 'id',
	        title: 'Mail 5',
	        lastTime: '23 Minutes ago',
	        state: 'state'
	    },
	    {
	        id: 'id',
	        title: 'Mail 5',
	        lastTime: '23 Minutes ago',
	        state: 'state'
	    },
	],

	currentUser: {
		photoURL: 'assets/images/avatars/hari.jpg',
		currentUserName: 'Hari Krishna'
	}
};


// WEBPACK FOOTER //
// E:/sree/New folder (3)/cdk-material-v2/src/app/core/toolbar/toolbar.helpers.ts